var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLlmGrok = function SvgLlmGrok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m8.046 12.838 6.926-5.119c.34-.25.825-.153.987.237.851 2.056.47 4.526-1.224 6.222S10.684 16.246 8.53 15.4L6.176 16.49c3.376 2.31 7.475 1.74 10.037-.827 2.032-2.035 2.661-4.808 2.073-7.308l.005.005c-.853-3.674.21-5.142 2.387-8.145q.078-.105.155-.215l-2.866 2.87v-.01l-9.923 9.98M6.617 14.083c-2.423-2.318-2.006-5.904.062-7.972 1.529-1.531 4.034-2.156 6.22-1.237l2.349-1.086a6.8 6.8 0 0 0-1.588-.867 7.79 7.79 0 0 0-8.466 1.705c-2.199 2.202-2.89 5.587-1.703 8.476.888 2.159-.567 3.686-2.031 5.227C.94 18.875.42 19.422 0 20l6.615-5.916"
  })));
};
export default SvgLlmGrok;